export default "__VITE_ASSET__1UPvXhA0__"